import { Box, Button } from '@material-ui/core';
import { generatePDF } from '../common';
import { DocumentTempPrint } from '../Sections/generator/print/DocumentTempPrint';
import MyIcon from './MyIcon';

export default function PrintDownload({
  company,
  printData,
  template,
  componentRef,
  handleReactPrint,
  isRTL,
  no,
  element,
  isNew,
}: any) {
  return (
    <Box
      style={{
        margin: 10,
        padding: 10,
        borderRadius: 10,
        display: 'flex',
      }}
    >
      <Box
        style={{
          display: isNew ? 'none' : 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 20,
          marginRight: 20,
        }}
      >
        <Button
          variant="text"
          endIcon={<MyIcon icon="print" size={20} />}
          onClick={handleReactPrint}
          style={{ marginLeft: 10, marginRight: 10 }}
        >
          Print
        </Button>
        <Button
          onClick={() => generatePDF({ no, template, element })}
          variant="text"
          endIcon={<MyIcon icon="pdf" size={20} />}
          style={{ marginLeft: 10, marginRight: 10 }}
        >
          Download
        </Button>
      </Box>
      <div
        id={element}
        style={{
          position: 'absolute',
          left: '-999em',
          direction: 'ltr',
          width:
            template?.size === 'POS'
              ? '80mm'
              : template?.size === 'A5'
              ? '148mm'
              : '210mm',
        }}
      >
        <DocumentTempPrint
          company={company}
          data={printData}
          template={template}
          ref={componentRef}
          isRTL={isRTL}
        ></DocumentTempPrint>
      </div>
    </Box>
  );
}
